import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M19_TOPICS, M19_MODULE_INFO } from '../data/mathExercises/M19_Locus';

const M19LocusExercise = ({ onProgress }) => {
  // Create some sample problems for M19
  const sampleProblems = [
    {
      id: 'M19_01_P001',
      topicId: 'M19_01',
      question: "動點 P 到定點 A(2, 3) 的距離恆為 5，求點 P 的軌跡方程",
      solution: "(x - 2)² + (y - 3)² = 25",
      explanation: "動點到定點距離恆定的軌跡是圓",
      difficulty: 1,
      order: 1,
      steps: ["設動點 P(x, y)", "根據條件：|PA| = 5", "√[(x-2)² + (y-3)²] = 5", "平方得：(x-2)² + (y-3)² = 25"]
    },
    {
      id: 'M19_02_P001',
      topicId: 'M19_02',
      question: "動點 P 到兩定點 A(1, 0) 和 B(5, 0) 的距離相等，求點 P 的軌跡方程",
      solution: "x = 3",
      explanation: "動點到兩定點等距離的軌跡是垂直平分線",
      difficulty: 1,
      order: 1,
      steps: ["設動點 P(x, y)", "|PA| = |PB|", "√[(x-1)² + y²] = √[(x-5)² + y²]", "化簡得 x = 3"]
    }
  ];
  
  return (
    <ExerciseInterface
      moduleInfo={M19_MODULE_INFO}
      topics={M19_TOPICS}
      problems={sampleProblems}
      onProgress={onProgress}
      className="m19-exercise"
    />
  );
};

export default M19LocusExercise; 